import { useTranslation } from 'react-i18next';
import { ColumnDef } from '@tanstack/react-table';
import { InfluencerYoutubeCompareTagRanking, InfluencerYoutubeAnalyticsAccountTagRanking } from '@anytag/graphql';
import {
  AnalyticsComparePostsAccount,
  AnalyticsCompareTagsRankingTable,
  AnalyticsCompareTagsRankingSlider
} from '@anytag/shared-organisms';
import { InfluencerYoutubeComparableAccountType } from '../types';

interface TemplateProps {
  data: InfluencerYoutubeCompareTagRanking;
  comparableAccounts: InfluencerYoutubeComparableAccountType[];
}

export const Template = ({ data, comparableAccounts }: TemplateProps) => {
  const { t } = useTranslation();

  const composeData = [
    data.mainAccount,
    ...(data.compareAccounts.reduce<InfluencerYoutubeAnalyticsAccountTagRanking[]>(
      (acc, curr) =>
        curr.accountId !== data.mainAccount.socialAccountId
          ? [...acc, { ...curr, socialAccountId: curr.accountId }]
          : acc,
      []
    ) || [])
  ];
  const tableData = comparableAccounts.map((account) => ({
    account,
    tagsRanking: composeData.find((item) => item.socialAccountId === account.id)?.tagsRanking
  }));

  const columns: ColumnDef<(typeof tableData)[number]>[] = [
    {
      size: 160,
      accessorKey: 'account',
      header: t<string>('HeaderColumn.Account'),
      cell: ({ row }) => (
        <AnalyticsComparePostsAccount
          account={{
            name: row.original.account.username,
            avatar: row.original.account.avatarUrl
          }}
        />
      )
    },
    {
      size: 2000, // take all the space
      accessorKey: 'tagsRanking',
      header: '',
      cell: ({ row }) => <AnalyticsCompareTagsRankingSlider data={row.original.tagsRanking} />
    }
  ];

  return <AnalyticsCompareTagsRankingTable data={tableData} columns={columns} />;
};
